var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"role-container",style:({ background: _vm.myColors.foregroundAccentActive })},[_c('p',{staticClass:"role-header",style:({ color: _vm.myColors.main })},[_vm._v("Role")]),_vm._l((_vm.roles),function(item,index){return _c('p',{key:index,style:({ color: _vm.myColors.foreground })},[_vm._v(" "+_vm._s(item)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }